function Header({
  title,
  category,
  desc,
  Icon,
  options,
  currentOption,
  fromColor,
  children
}) {
  return (
    
    <div className="flex flex-col md:flex-row bg-dark-5 ">
      {/* <div className="w-full md:w-1/5">&nbsp;</div> */}
      <div className="bg-dark-5 text-white md:px-8 md:pl-0 pt-4  mb-px">
        <div className="container mx-auto px-2 sm:px-4 flex items-center">
          {Icon ? (
            <div className={`mr-4 hidden md:inline-block text-c-yellow`}>
              <Icon className="h-16 w-16 mb-4 mt-4" />
            </div>
          ) : null}
          <div>
            <div className={`text-sm font-medium text-white -mb-1`}>
              {category}
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl text-white flex align-center -mb-1">
              {title}
            </h2>
            <p className="text-base text-gray-300 text-sm md:text-md lg:text-lg md:mt-2  lg:mx-0 ">
              {desc}
            </p>
          </div>
        </div>

        <div className="container mx-auto px-2 sm:px-4 pt-4 select-none ">
          {options && (
            <div className="flex flex-nowrap whitespace-nowrap pb-2 sm:pb-0 styled-scrollbar-mobile max-w-full overflow-auto align-bottom text-left transform transition-all sm:align-middle transition inline-flex border-radius-12">
              {options.map((option, index) => (
                <Option
                  key={index}
                  currentOption={currentOption}
                  {...option}
                  currentIndex={index}
                  length={options.length - 1}
                />
              ))}
            </div>
          )}

          {children}
        </div>
      </div>
    </div>
  );
}

export function Option({
  title,
  Icon,
  onClick,
  currentOption,
  color,
  currentIndex,
  length,
}) {
  let active = currentOption === title;
  return (
    <div
      className={`lg:py-4 lg:px-8 py-3 px-6 rounded-t-xl ${
        currentIndex !== length && `mr-0`
      } flex  transition text-${
        active ? `c-yellow` : ""
      } font-medium  bg-${
        active ? `c-yellow` : "c-gray in-active-tab"
      }  cursor-pointer `}
      onClick={() => onClick(title)}
    >
      <div
        className={`md:mr-4  transition flex-shrink-0 inline-flex items-center justify-center text-sm h-6 w-6  text-${
          active ? "white" : "c-yellow"
        }`}
      >
        <Icon
          className={`h-4 w-4 text-${active ? "black" : "c-yellow"}`}
          aria-hidden="true"
        />
      </div>
      <div className={`text-${active ? "black" : "c-yellow"} ml-1`}>{title}</div>
    </div>
  );
}

export default Header;
